import RequestMoreInfo from "./requestMoreInfo"

export default RequestMoreInfo
